import { Box } from '@mui/material'
import PlcHeroSection from '../components/plc/PlcHeroSection'
import PlcInfoCards from '../components/plc/PlcInfoCards'
import PlcAboutSection from '../components/plc/PlcAboutSection'
import PlcAudienceSection from '../components/plc/PlcAudienceSection'
import PlcCtaBanner from '../components/plc/PlcCtaBanner'
import PlcSpeakersSection from '../components/plc/PlcSpeakersSection'
import { mobilePaddingX } from '../theme/mobileLayout'
import { programSectionGap } from '../components/programs/programLayout'

const sectionWrapperSx = {
  width: '100%',
  maxWidth: 1920,
  mx: 'auto',
  px: mobilePaddingX,
  boxSizing: 'border-box',
}

export default function PlcPage() {
  return (
    <Box sx={{ bgcolor: '#fffefa' }}>
      <PlcHeroSection />

      <Box sx={{ ...sectionWrapperSx, pb: programSectionGap }}>
        <Box
          sx={{
            maxWidth: 1520,
            mx: 'auto',
            display: 'flex',
            flexDirection: 'column',
            gap: programSectionGap,
          }}
        >
          <PlcInfoCards />
          <PlcAboutSection />
          <PlcAudienceSection />
          <PlcCtaBanner />
          <PlcSpeakersSection />
        </Box>
      </Box>
    </Box>
  )
}
